import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "container"
}
const _hoisted_3 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isProcessing === true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Generating... "))
      : _createCommentVNode("v-if", true),
    (_ctx.isProcessing === false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _cache[7] || (_cache[7] = _createElementVNode("p", { class: "mb-0" }, "Respondent's access url:", -1 /* CACHED */)),
          _createElementVNode("p", null, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.AccessUrl) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [
                _vModelText,
                _ctx.AccessUrl,
                void 0,
                { trim: true }
              ]
            ])
          ]),
          _createElementVNode("p", null, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.GenerateVotesForAllRespondents) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelCheckbox, _ctx.GenerateVotesForAllRespondents]
            ]),
            _cache[3] || (_cache[3] = _createTextVNode(" Generate votes for all individual respondents in that survey", -1 /* CACHED */))
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.GenerateVotesCommand && _ctx.GenerateVotesCommand(...args))),
              disabled: !_ctx.AccessUrl,
              type: "button",
              class: "btn btn-primary"
            }, "Generate", 8 /* PROPS */, _hoisted_3)
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}